import { apiSlice } from './apiSlice';
import { AGENCY_SHIFTS_URL } from '../constants';

export const agencyShiftApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Open, unfilled shifts currently inside this agency's own
    // daysToShiftStart window (server-computed — the client never sends or
    // trusts a window boundary).
    getAvailableAgencyShifts: builder.query({
      query: () => `${AGENCY_SHIFTS_URL}/available`,
      providesTags: ['AgencyShift'],
    }),

    // Shifts this agency currently holds.
    getMyAgencyShifts: builder.query({
      query: ({ startDate, endDate } = {}) => ({
        url: `${AGENCY_SHIFTS_URL}/mine`,
        params: startDate && endDate ? { startDate, endDate } : undefined,
      }),
      providesTags: ['AgencyShift'],
    }),

    // First-come-first-served grab. A 409 here means another agency won the
    // race — the caller should surface the message and refetch the list.
    grabAgencyShift: builder.mutation({
      query: ({ shiftId, workerName, workerContact, workerEmail }) => ({
        url: `${AGENCY_SHIFTS_URL}/${shiftId}/grab`,
        method: 'POST',
        body: { workerName, workerContact, workerEmail },
      }),
      invalidatesTags: ['AgencyShift'],
    }),

    // Change the worker assigned to a shift this agency already holds —
    // allowed any time before the shift starts.
    reassignAgencyShift: builder.mutation({
      query: ({ shiftId, workerName, workerContact, workerEmail }) => ({
        url: `${AGENCY_SHIFTS_URL}/${shiftId}/reassign`,
        method: 'PUT',
        body: { workerName, workerContact, workerEmail },
      }),
      invalidatesTags: ['AgencyShift'],
    }),

    // Cancel a shift this agency holds — same effect as the admin's "Cancel
    // Agency Shift" action (agencyCancelled: true, Ref/agency trail kept on
    // the record), always agency-initiated (no charge), and automatically
    // emails the nursing bank since there's no staff picker here.
    cancelAgencyShift: builder.mutation({
      query: ({ shiftId }) => ({
        url: `${AGENCY_SHIFTS_URL}/${shiftId}/cancel`,
        method: 'PUT',
      }),
      invalidatesTags: ['AgencyShift'],
    }),
  }),
});

export const {
  useGetAvailableAgencyShiftsQuery,
  useGetMyAgencyShiftsQuery,
  useGrabAgencyShiftMutation,
  useReassignAgencyShiftMutation,
  useCancelAgencyShiftMutation,
} = agencyShiftApiSlice;
